'use strict';
module.exports = require('os-homedir')();



//////////////////
// WEBPACK FOOTER
// ./~/eslint/~/user-home/index.js
// module id = 2774
// module chunks = 0